module.exports = __webpack_public_path__ + "static/media/maestro_logo_mark_primary.99320208.svg";